/**
 * Layer-specific variant type options for Create Variant flow and registration.
 * Single source of truth for variant type dropdown values and labels.
 */

export interface VariantTypeOption {
  value: string;
  label: string;
}

export const VARIANT_TYPE_OPTIONS_BY_LAYER: Record<string, VariantTypeOption[]> = {
  G: [
    { value: 'cover', label: 'Cover' },
    { value: 'remix', label: 'Remix' },
    { value: 'acoustic', label: 'Acoustic' },
    { value: 'instrumental', label: 'Instrumental' },
    { value: 'mashup', label: 'Mashup' },
    { value: 'karaoke', label: 'Karaoke' },
  ],
  S: [
    { value: 'hair', label: 'Hair' },
    { value: 'makeup', label: 'Makeup' },
    { value: 'musical-style', label: 'Musical Style' },
    { value: 'career', label: 'Career' },
    { value: 'personality', label: 'Personality' },
  ],
  L: [
    { value: 'casual', label: 'Casual' },
    { value: 'formal', label: 'Formal' },
    { value: 'party', label: 'Party' },
    { value: 'work', label: 'Work' },
    { value: 'seasonal', label: 'Seasonal' },
  ],
  M: [
    { value: 'remix', label: 'Remix' },
    { value: 'tutorial', label: 'Tutorial' },
    { value: 'speed-variation', label: 'Speed Variation' },
    { value: 'style-adaptation', label: 'Style Adaptation' },
  ],
  W: [
    { value: 'lighting-change', label: 'Lighting Change' },
    { value: 'time-of-day', label: 'Time of Day' },
    { value: 'season-change', label: 'Season Change' },
    { value: 'mood-adaptation', label: 'Mood Adaptation' },
  ],
  B: [
    { value: 'color', label: 'Color Variation' },
    { value: 'size', label: 'Size Variation' },
    { value: 'material', label: 'Material Change' },
    { value: 'seasonal', label: 'Seasonal Edition' },
    { value: 'limited', label: 'Limited Edition' },
    { value: 'collaboration', label: 'Brand Collaboration' },
  ],
};

export function getVariantTypeOptions(layer: string): VariantTypeOption[] {
  return VARIANT_TYPE_OPTIONS_BY_LAYER[layer] ?? [];
}
